export const trainerLeaveTypeColumns = [
    {
        field: "employee_role",
        headerName: "Employee Role",
        width: 160,
    },
    {
        field: "totalLeaves",
        headerName: "Total Leaves",
        width: 160,
    },
    {
        field: "carryForwardLeaves",
        headerName: "Carry Forward Leaves",
        width: 160
    },
];